<template>
  <div id="app">
    <!-- <div v-if="type==='loader'">
      <loader></loader>
    </div>
    <div v-else-if="type==='student'">
      <student :user="user" :formStatus="formStatus" :expiringFields="expiringFields"></student>
    </div>
    <div v-else-if="type==='admin'">
      <admin :user="user"></admin>
    </div>
    <div v-else>
      <unauthorized></unauthorized>
    </div> -->
    <Closed ></Closed>
  </div>
</template>

<script>
import Admin from './components/Admin/Admin';
import Loader from './components/Loader/Loader';
import Student from './components/Student/Student';
import Unauthorized from './components/Unauthorized/Unauthorized';

import Closed from "./components/Student/Closed.vue"

export default {
  name: 'app',
  components: {
    Admin,
    Loader,
    Unauthorized,
    Student,
    Closed
  },
  data() {
    return {
      expiringFields: [],
      formStatus: 'closed',
      user: {
        commonName: '',
        record: {},
        type: ''
      },
      type: 'loader'
    }
  },
  methods: {
    getUser() {
      const that = this;
      let URL = 'https://HOSTNAME/cgi-bin/mkvn-sci-backend/controller.sci.pl';
      URL = URL.replace("HOSTNAME", location.hostname);

      // Fetch authorization
      fetch(URL, {
          method: 'GET'
        })
        .then(function (response) {
          // Return response
          return response.json();
        })
        .then(function (json) {
          // Resolve response
          if (json.result.match(/^OK/i)) {
            // Store data
            that.user.commonName = json.commonName;
            that.user.record = json.record;
            that.user.type = json.sessionType;
            that.formStatus = json.formStatus;
            that.expiringFields = json.expiringFields;

            // Student
            if (json.sessionType.match(/student/i)) {
              that.type = 'student';
            } else if (json.sessionType.match(/admin/i)) {
              that.type = 'admin';
            } else {
              // TODO: error handling
              that.type = 'unauthorized';
            }
          } else {
            // TODO: error handling
            that.type = 'unauthorized';
          }
        })
        .catch(function (error) {
          // TODO: error handling
          that.type = 'unauthorized';
        });
    }
  },
  created() {
    // Fetch user
    //this.getUser();
  }
}
</script>